import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../config';
import { formatDate } from '../utils/formatDate';
import './DataPage.css';

const styles = {
  page: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
  },
  breadcrumb: {
    fontSize: '13px',
    color: '#999',
    marginBottom: '4px',
  },
  breadcrumbLink: {
    color: '#1976d2',
    textDecoration: 'none',
    cursor: 'pointer',
  },
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '24px',
    flexWrap: 'wrap',
    gap: '12px',
  },
  pageIcon: {
    fontSize: '1.5rem',
    lineHeight: 1,
  },
  pageTitle: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#1a1a2e',
    margin: '0 0 2px 0',
  },
  pageSubtitle: {
    fontSize: '0.85rem',
    color: '#666',
    margin: 0,
  },
  filtersCard: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    marginBottom: '24px',
    display: 'flex',
    gap: '16px',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
  },
  filterGroup: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '160px',
  },
  filterLabel: {
    fontSize: '12px',
    color: '#666',
    marginBottom: '6px',
    fontWeight: '500',
  },
  input: {
    padding: '10px 12px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '14px',
    color: '#333',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },
  select: {
    padding: '10px 12px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '14px',
    color: '#333',
    outline: 'none',
    backgroundColor: '#fff',
    cursor: 'pointer',
    width: '100%',
    boxSizing: 'border-box',
  },
  searchBtn: {
    padding: '10px 24px',
    backgroundColor: '#1976d2',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'background-color 0.2s',
  },
  clearBtn: {
    padding: '10px 20px',
    backgroundColor: '#f5f5f5',
    color: '#666',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '14px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'background-color 0.2s',
  },
  exportBtn: {
    padding: '10px 20px',
    backgroundColor: '#2e7d32',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'background-color 0.2s',
  },
  printBtn: {
    padding: '10px 20px',
    backgroundColor: '#555',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'background-color 0.2s',
  },
  summaryCards: {
    display: 'flex',
    gap: '16px',
    marginBottom: '24px',
    flexWrap: 'wrap',
  },
  summaryCard: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '20px 24px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    flex: '1',
    minWidth: '200px',
  },
  summaryLabel: {
    fontSize: '12px',
    color: '#666',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '8px',
  },
  summaryValue: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#333',
  },
  summaryValueGreen: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#2e7d32',
  },
  grupoCard: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    overflow: 'hidden',
    marginBottom: '24px',
  },
  grupoHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 20px',
    backgroundColor: '#f8f9fa',
    borderBottom: '2px solid #e0e0e0',
    flexWrap: 'wrap',
    gap: '8px',
  },
  grupoTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#333',
    margin: 0,
  },
  grupoSubtitle: {
    fontSize: '13px',
    color: '#666',
    fontWeight: '400',
  },
  grupoSubtotal: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#1976d2',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '13px',
  },
  th: {
    padding: '12px 14px',
    textAlign: 'left',
    backgroundColor: '#fafafa',
    color: '#555',
    fontWeight: '600',
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    borderBottom: '2px solid #eee',
    whiteSpace: 'nowrap',
  },
  thRight: {
    padding: '12px 14px',
    textAlign: 'right',
    backgroundColor: '#fafafa',
    color: '#555',
    fontWeight: '600',
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    borderBottom: '2px solid #eee',
    whiteSpace: 'nowrap',
  },
  td: {
    padding: '10px 14px',
    borderBottom: '1px solid #f0f0f0',
    color: '#333',
  },
  tdRight: {
    padding: '10px 14px',
    borderBottom: '1px solid #f0f0f0',
    color: '#333',
    textAlign: 'right',
    fontVariantNumeric: 'tabular-nums',
  },
  rowEven: {
    backgroundColor: '#fff',
  },
  rowOdd: {
    backgroundColor: '#fafafa',
  },
  subtotalRow: {
    backgroundColor: '#e8f0fe',
  },
  subtotalTd: {
    padding: '12px 14px',
    fontWeight: '600',
    color: '#1976d2',
    borderBottom: 'none',
  },
  subtotalTdRight: {
    padding: '12px 14px',
    fontWeight: '600',
    color: '#1976d2',
    borderBottom: 'none',
    textAlign: 'right',
    fontVariantNumeric: 'tabular-nums',
  },
  totalGeralCard: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    padding: '20px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
  },
  totalGeralLabel: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#333',
  },
  totalGeralValue: {
    fontSize: '20px',
    fontWeight: '700',
    color: '#2e7d32',
  },
  badge: {
    display: 'inline-block',
    padding: '3px 8px',
    borderRadius: '10px',
    fontSize: '11px',
    fontWeight: '500',
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '60px',
    color: '#666',
    fontSize: '16px',
  },
  emptyState: {
    textAlign: 'center',
    padding: '60px 20px',
    color: '#999',
  },
  emptyTitle: {
    fontSize: '18px',
    fontWeight: '500',
    color: '#666',
    margin: '0 0 8px 0',
  },
  emptyText: {
    fontSize: '14px',
    color: '#999',
    margin: 0,
  },
};

const multiSelectStyles = {
  container: {
    position: 'relative',
    width: '100%',
  },
  trigger: {
    padding: '10px 12px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '14px',
    color: '#333',
    backgroundColor: '#fff',
    cursor: 'pointer',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
    minHeight: '40px',
  },
  triggerActive: {
    borderColor: '#1976d2',
    boxShadow: '0 0 0 1px #1976d2',
  },
  triggerText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
  },
  arrow: {
    fontSize: '10px',
    color: '#999',
    flexShrink: 0,
  },
  dropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    marginTop: '4px',
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderRadius: '6px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
    zIndex: 1000,
    maxHeight: '240px',
    overflowY: 'auto',
  },
  option: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 12px',
    fontSize: '13px',
    color: '#333',
    cursor: 'pointer',
    borderBottom: '1px solid #f5f5f5',
    transition: 'background-color 0.1s',
  },
  checkbox: {
    width: '16px',
    height: '16px',
    accentColor: '#1976d2',
    cursor: 'pointer',
    flexShrink: 0,
  },
  selectedCount: {
    display: 'inline-block',
    backgroundColor: '#1976d2',
    color: '#fff',
    borderRadius: '10px',
    padding: '1px 7px',
    fontSize: '11px',
    fontWeight: '600',
    marginLeft: '4px',
    flexShrink: 0,
  },
};

function MultiSelect({ options, selected, onChange, placeholder }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const toggle = (value) => {
    if (selected.includes(value)) {
      onChange(selected.filter(v => v !== value));
    } else {
      onChange([...selected, value]);
    }
  };

  const label = selected.length === 0
    ? placeholder
    : options.filter(o => selected.includes(o.value)).map(o => o.label).join(', ');

  return (
    <div style={multiSelectStyles.container} ref={ref}>
      <div
        style={{ ...multiSelectStyles.trigger, ...(open ? multiSelectStyles.triggerActive : {}) }}
        onClick={() => setOpen(!open)}
      >
        <span style={multiSelectStyles.triggerText}>{label}</span>
        {selected.length > 0 && (
          <span style={multiSelectStyles.selectedCount}>{selected.length}</span>
        )}
        <span style={multiSelectStyles.arrow}>{open ? '\u25B2' : '\u25BC'}</span>
      </div>
      {open && (
        <div style={multiSelectStyles.dropdown}>
          {options.map(opt => (
            <label
              key={opt.value}
              style={multiSelectStyles.option}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f5f7fa'; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
            >
              <input
                type="checkbox"
                checked={selected.includes(opt.value)}
                onChange={() => toggle(opt.value)}
                style={multiSelectStyles.checkbox}
              />
              {opt.label}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}

const printStyles = `
@media print {
  .no-print { display: none !important; }
  .sidebar-dashboard, .mobile-menu-toggle, .mobile-overlay { display: none !important; }
  .main-container { margin-left: 0 !important; padding: 10px !important; }
  .app-container { display: block !important; }
  body { background: #fff !important; }
  .print-report { background: #fff !important; }
  .print-report * { box-shadow: none !important; }
}
`;

const STATUS_EXAME_MAP = {
  'P': { label: 'Pendente', color: '#6a1b9a', bg: '#f3e5f5' },
  'M': { label: 'Parcial', color: '#e65100', bg: '#fff3e0' },
  'D': { label: 'Digitado', color: '#1565c0', bg: '#e3f2fd' },
  'F': { label: 'Falta conferir', color: '#c62828', bg: '#fce4ec' },
  'I': { label: 'Impresso (Zap)', color: '#2e7d32', bg: '#e8f5e9' },
  'E': { label: 'Entregue', color: '#37474f', bg: '#eceff1' },
};

const STATUS_EXAME_OPTIONS = Object.entries(STATUS_EXAME_MAP).map(([key, val]) => ({
  value: key,
  label: val.label,
}));

function getDefaultDataInicio() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;
}

function getDefaultDataFim() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

// formatDate importado de ../utils/formatDate

function formatCurrency(value) {
  if (value === null || value === undefined || value === '') return 'R$ 0,00';
  const num = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(num)) return 'R$ 0,00';
  return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

function getStatusExameBadge(situacao) {
  const s = (situacao || '').trim();
  const info = STATUS_EXAME_MAP[s];
  if (info) {
    return { ...styles.badge, backgroundColor: info.bg, color: info.color };
  }
  return { ...styles.badge, backgroundColor: '#f5f5f5', color: '#666' };
}

function getStatusExameLabel(situacao) {
  const s = (situacao || '').trim();
  const info = STATUS_EXAME_MAP[s];
  return info ? info.label : s || '-';
}

function RelatorioFaturamento() {
  const navigate = useNavigate();
  const [dataInicio, setDataInicio] = useState(getDefaultDataInicio());
  const [dataFim, setDataFim] = useState(getDefaultDataFim());
  const [convenioFilter, setConvenioFilter] = useState([]);
  const [localFilter, setLocalFilter] = useState([]);
  const [statusExameFilter, setStatusExameFilter] = useState([]);
  const [statusColetaFilter, setStatusColetaFilter] = useState('');
  const [conveniosList, setConveniosList] = useState([]);
  const [locaisList, setLocaisList] = useState([]);
  const [relatorio, setRelatorio] = useState(null);
  const [loading, setLoading] = useState(false);
  const [gerado, setGerado] = useState(false);

  const fetchFiltros = useCallback(async (di, df) => {
    try {
      const params = new URLSearchParams();
      if (di) params.append('dataInicio', di);
      if (df) params.append('dataFim', df);
      const response = await axios.get(`${API_URL}/financeiro/relatorio/filtros?${params.toString()}`);
      setConveniosList(Array.isArray(response.data.convenios) ? response.data.convenios : []);
      setLocaisList(Array.isArray(response.data.locais) ? response.data.locais : []);
    } catch (err) {
      console.error('Erro ao buscar filtros:', err);
    }
  }, []);

  useEffect(() => {
    fetchFiltros(dataInicio, dataFim);
  }, [dataInicio, dataFim, fetchFiltros]);

  const gerarRelatorio = useCallback(async () => {
    setLoading(true);
    setGerado(true);
    try {
      const params = new URLSearchParams();
      params.append('dataInicio', dataInicio);
      params.append('dataFim', dataFim);
      if (convenioFilter.length > 0) params.append('convenio', convenioFilter.join(','));
      if (localFilter.length > 0) params.append('local', localFilter.join(','));
      if (statusExameFilter.length > 0) params.append('statusExame', statusExameFilter.join(','));
      if (statusColetaFilter) params.append('statusColeta', statusColetaFilter);

      const response = await axios.get(`${API_URL}/financeiro/relatorio/faturamento?${params.toString()}`);
      setRelatorio(response.data);
    } catch (err) {
      console.error('Erro ao gerar relatório:', err);
      setRelatorio(null);
    } finally {
      setLoading(false);
    }
  }, [dataInicio, dataFim, convenioFilter, localFilter, statusExameFilter, statusColetaFilter]);

  const limparFiltros = () => {
    setDataInicio(getDefaultDataInicio());
    setDataFim(getDefaultDataFim());
    setConvenioFilter([]);
    setLocalFilter([]);
    setStatusExameFilter([]);
    setStatusColetaFilter('');
    setRelatorio(null);
    setGerado(false);
  };

  const convenioOptions = conveniosList.map(c => ({
    value: c.CONVENIO,
    label: c.CONVENIO_NOME || c.CONVENIO,
  }));

  const localOptions = locaisList.map(l => ({
    value: l.LOCAL,
    label: l.LOCAL_NOME || l.LOCAL,
  }));

  const exportarCSV = () => {
    if (!relatorio || !relatorio.grupos || relatorio.grupos.length === 0) return;

    const separator = ';';
    const lines = [];
    lines.push([
      'Convênio', 'Plano', 'Protocolo', 'Data', 'Paciente', 'Unidade',
      'Exame', 'Descrição', 'Código', 'Status', 'Coleta', 'Data Coleta',
      'Nº Guia', 'Faturar Em', 'Valor'
    ].join(separator));

    for (const grupo of relatorio.grupos) {
      for (const item of grupo.itens) {
        const valor = typeof item.VALOR === 'number' ? item.VALOR : parseFloat(item.VALOR) || 0;
        lines.push([
          `"${(grupo.convenioNome || grupo.convenio || '').replace(/"/g, '""')}"`,
          `"${(item.PLANO || '').replace(/"/g, '""')}"`,
          item.PROTOCOLO || '',
          formatDate(item.DATA),
          `"${(item.PACIENTE_NOME || '').replace(/"/g, '""')}"`,
          `"${(item.LOCAL_NOME || item.LOCAL || '').replace(/"/g, '""')}"`,
          `"${(item.EXAME || '').replace(/"/g, '""')}"`,
          `"${(item.EXAME_DESCRICAO || '').replace(/"/g, '""')}"`,
          `"${(item.CODIGO_PROCEDIMENTO || '').replace(/"/g, '""')}"`,
          getStatusExameLabel(item.EXAME_SITUACAO),
          (item.MATERIALCOLHIDO || '').trim() === 'T' ? 'Sim' : 'Não',
          formatDate(item.DATACOLETA),
          `"${(item.NUMEROGUIA || '').replace(/"/g, '""')}"`,
          formatDate(item.FATURAEM),
          valor.toFixed(2).replace('.', ','),
        ].join(separator));
      }
      lines.push([
        `"Subtotal ${grupo.convenioNome || grupo.convenio}"`,
        '', '', '', '', '', '', '', '', '', '', '', '', '',
        grupo.total.toFixed(2).replace('.', ','),
      ].join(separator));
      lines.push('');
    }

    lines.push([
      '"TOTAL GERAL"',
      '', '', '', '', '', '', '', '', '', '', '', '', '',
      relatorio.totalGeral.toFixed(2).replace('.', ','),
    ].join(separator));

    const BOM = '\uFEFF';
    const csvContent = BOM + lines.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `relatorio_faturamento_${dataInicio}_${dataFim}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  const imprimir = () => {
    window.print();
  };

  return (
    <div className="data-page print-report" style={styles.page}>
      <style>{printStyles}</style>

      {/* Breadcrumb */}
      <div style={styles.breadcrumb} className="no-print">
        <span style={styles.breadcrumbLink}>Inicio</span>
        <span> / </span>
        <span style={styles.breadcrumbLink}>Financeiro</span>
        <span> / </span>
        <span>Relatórios de Faturamento</span>
      </div>

      {/* Header */}
      <div style={styles.pageHeader}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={styles.pageIcon}>📊</span>
          <div>
            <h1 style={styles.pageTitle}>Relatórios de Faturamento</h1>
            <p style={styles.pageSubtitle}>
              Relatório por convênio baseado nas guias dos atendimentos
            </p>
          </div>
        </div>
      </div>

      {/* Filtros */}
      <div className="responsive-flex no-print page-filters" style={styles.filtersCard}>
        <div style={styles.filterGroup}>
          <label style={styles.filterLabel}>Data Inicio</label>
          <input
            type="date"
            value={dataInicio}
            onChange={(e) => setDataInicio(e.target.value)}
            style={styles.input}
          />
        </div>
        <div style={styles.filterGroup}>
          <label style={styles.filterLabel}>Data Fim</label>
          <input
            type="date"
            value={dataFim}
            onChange={(e) => setDataFim(e.target.value)}
            style={styles.input}
          />
        </div>
        <div style={{ ...styles.filterGroup, minWidth: '200px' }}>
          <label style={styles.filterLabel}>Convênio</label>
          <MultiSelect
            options={convenioOptions}
            selected={convenioFilter}
            onChange={setConvenioFilter}
            placeholder="Todos"
          />
        </div>
        <div style={styles.filterGroup}>
          <label style={styles.filterLabel}>Unidade</label>
          <MultiSelect
            options={localOptions}
            selected={localFilter}
            onChange={setLocalFilter}
            placeholder="Todas"
          />
        </div>
        <div style={{ ...styles.filterGroup, minWidth: '180px' }}>
          <label style={styles.filterLabel}>Status Exame</label>
          <MultiSelect
            options={STATUS_EXAME_OPTIONS}
            selected={statusExameFilter}
            onChange={setStatusExameFilter}
            placeholder="Todos"
          />
        </div>
        <div style={styles.filterGroup}>
          <label style={styles.filterLabel}>Material Colhido</label>
          <select
            value={statusColetaFilter}
            onChange={(e) => setStatusColetaFilter(e.target.value)}
            style={styles.select}
          >
            <option value="">Todos</option>
            <option value="T">Sim</option>
            <option value="F">Não</option>
          </select>
        </div>
        <button
          style={styles.searchBtn}
          onClick={gerarRelatorio}
          onMouseEnter={(e) => { e.target.style.backgroundColor = '#1565c0'; }}
          onMouseLeave={(e) => { e.target.style.backgroundColor = '#1976d2'; }}
        >
          Gerar Relatório
        </button>
        <button
          style={styles.clearBtn}
          onClick={limparFiltros}
          onMouseEnter={(e) => { e.target.style.backgroundColor = '#eee'; }}
          onMouseLeave={(e) => { e.target.style.backgroundColor = '#f5f5f5'; }}
        >
          Limpar
        </button>
        {relatorio && relatorio.grupos && relatorio.grupos.length > 0 && (
          <>
            <button
              style={styles.exportBtn}
              onClick={exportarCSV}
              onMouseEnter={(e) => { e.target.style.backgroundColor = '#1b5e20'; }}
              onMouseLeave={(e) => { e.target.style.backgroundColor = '#2e7d32'; }}
            >
              Exportar CSV
            </button>
            <button
              style={styles.printBtn}
              onClick={imprimir}
              onMouseEnter={(e) => { e.target.style.backgroundColor = '#333'; }}
              onMouseLeave={(e) => { e.target.style.backgroundColor = '#555'; }}
            >
              Imprimir
            </button>
          </>
        )}
      </div>

      {/* Conteúdo */}
      {loading ? (
        <div style={styles.loading}>Gerando relatório...</div>
      ) : !gerado ? (
        <div style={{ ...styles.emptyState, backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
          <p style={styles.emptyTitle}>Selecione os filtros e clique em "Gerar Relatório"</p>
          <p style={styles.emptyText}>O relatório será agrupado por convênio com base nas guias dos atendimentos.</p>
        </div>
      ) : !relatorio || !relatorio.grupos || relatorio.grupos.length === 0 ? (
        <div style={{ ...styles.emptyState, backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
          <p style={styles.emptyTitle}>Nenhum dado encontrado</p>
          <p style={styles.emptyText}>Tente ajustar o período ou os filtros de busca.</p>
        </div>
      ) : (
        <>
          {/* Cards resumo */}
          <div style={styles.summaryCards}>
            <div style={styles.summaryCard}>
              <div style={styles.summaryLabel}>Convênios</div>
              <div style={styles.summaryValue}>{relatorio.grupos.length}</div>
            </div>
            <div style={styles.summaryCard}>
              <div style={styles.summaryLabel}>Total de Exames</div>
              <div style={styles.summaryValue}>{relatorio.totalItens.toLocaleString('pt-BR')}</div>
            </div>
            <div style={styles.summaryCard}>
              <div style={styles.summaryLabel}>Valor Total</div>
              <div style={styles.summaryValueGreen}>{formatCurrency(relatorio.totalGeral)}</div>
            </div>
          </div>

          {/* Tabela resumo por convênio */}
          {(() => {
            const statusKeys = Object.keys(STATUS_EXAME_MAP);
            const countStatus = (itens, key) => itens.filter(i => (i.EXAME_SITUACAO || '').trim() === key).length;
            const allItens = relatorio.grupos.flatMap(g => g.itens);
            return (
              <div style={styles.grupoCard}>
                <div style={{ ...styles.grupoHeader, borderBottom: 'none' }}>
                  <h3 style={styles.grupoTitle}>Resumo por Convênio</h3>
                </div>
                <div style={styles.tableWrapper}>
                  <table style={styles.table}>
                    <thead>
                      <tr>
                        <th style={styles.th}>Convênio</th>
                        <th style={{ ...styles.th, textAlign: 'center' }}>Atend.</th>
                        <th style={{ ...styles.th, textAlign: 'center' }}>Exames</th>
                        {statusKeys.map(k => (
                          <th key={k} style={{ ...styles.th, textAlign: 'center', fontSize: '10px' }}>
                            {STATUS_EXAME_MAP[k].label}
                          </th>
                        ))}
                        <th style={styles.thRight}>Valor</th>
                        <th style={{ ...styles.th, textAlign: 'center' }}>%</th>
                      </tr>
                    </thead>
                    <tbody>
                      {relatorio.grupos.map((grupo, index) => {
                        const pct = relatorio.totalGeral > 0
                          ? ((grupo.total / relatorio.totalGeral) * 100).toFixed(1)
                          : '0.0';
                        const atendimentos = new Set(grupo.itens.map(i => i.SOLICITACAO_ID)).size;
                        return (
                          <tr key={grupo.convenio} style={index % 2 === 0 ? styles.rowEven : styles.rowOdd}>
                            <td style={styles.td}>
                              <strong>{grupo.convenioNome || grupo.convenio}</strong>
                              {grupo.convenio !== grupo.convenioNome && grupo.convenioNome && (
                                <span style={{ color: '#999', fontSize: '12px', marginLeft: '6px' }}>({grupo.convenio})</span>
                              )}
                            </td>
                            <td style={{ ...styles.td, textAlign: 'center' }}>{atendimentos.toLocaleString('pt-BR')}</td>
                            <td style={{ ...styles.td, textAlign: 'center' }}>{grupo.totalItens.toLocaleString('pt-BR')}</td>
                            {statusKeys.map(k => {
                              const count = countStatus(grupo.itens, k);
                              return (
                                <td key={k} style={{ ...styles.td, textAlign: 'center' }}>
                                  {count > 0 ? (
                                    <span style={{ ...styles.badge, backgroundColor: STATUS_EXAME_MAP[k].bg, color: STATUS_EXAME_MAP[k].color }}>
                                      {count}
                                    </span>
                                  ) : (
                                    <span style={{ color: '#ccc' }}>-</span>
                                  )}
                                </td>
                              );
                            })}
                            <td style={styles.tdRight}>{formatCurrency(grupo.total)}</td>
                            <td style={{ ...styles.td, textAlign: 'center' }}>
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                                <div style={{ width: '60px', height: '6px', backgroundColor: '#eee', borderRadius: '3px', overflow: 'hidden' }}>
                                  <div style={{ width: `${Math.min(parseFloat(pct), 100)}%`, height: '100%', backgroundColor: '#1976d2', borderRadius: '3px' }} />
                                </div>
                                <span style={{ fontSize: '12px', color: '#666', minWidth: '40px' }}>{pct}%</span>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                      <tr style={styles.subtotalRow}>
                        <td style={styles.subtotalTd}><strong>Total</strong></td>
                        <td style={{ ...styles.subtotalTd, textAlign: 'center' }}>
                          {new Set(allItens.map(i => i.SOLICITACAO_ID)).size.toLocaleString('pt-BR')}
                        </td>
                        <td style={{ ...styles.subtotalTd, textAlign: 'center' }}>{relatorio.totalItens.toLocaleString('pt-BR')}</td>
                        {statusKeys.map(k => {
                          const count = countStatus(allItens, k);
                          return (
                            <td key={k} style={{ ...styles.subtotalTd, textAlign: 'center' }}>
                              {count > 0 ? count.toLocaleString('pt-BR') : '-'}
                            </td>
                          );
                        })}
                        <td style={styles.subtotalTdRight}>{formatCurrency(relatorio.totalGeral)}</td>
                        <td style={{ ...styles.subtotalTd, textAlign: 'center', fontSize: '12px' }}>100%</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })()}

          {/* Grupos detalhados por convênio */}
          {relatorio.grupos.map((grupo) => (
            <div key={grupo.convenio} style={styles.grupoCard}>
              <div style={styles.grupoHeader}>
                <div>
                  <h3 style={styles.grupoTitle}>
                    {grupo.convenioNome || grupo.convenio}
                  </h3>
                  <span style={styles.grupoSubtitle}>
                    {grupo.convenio !== grupo.convenioNome && grupo.convenioNome ? `(${grupo.convenio}) - ` : ''}
                    {grupo.totalItens} {grupo.totalItens === 1 ? 'exame' : 'exames'}
                  </span>
                </div>
                <span style={styles.grupoSubtotal}>{formatCurrency(grupo.total)}</span>
              </div>
              <div style={styles.tableWrapper}>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.th}>Protocolo</th>
                      <th style={styles.th}>Data</th>
                      <th style={{ ...styles.th, minWidth: '180px' }}>Paciente</th>
                      <th style={styles.th}>Unidade</th>
                      <th style={styles.th}>Exame</th>
                      <th style={{ ...styles.th, minWidth: '140px' }}>Descrição</th>
                      <th style={styles.th}>Código</th>
                      <th style={styles.th}>Status</th>
                      <th style={styles.th}>Coleta</th>
                      <th style={styles.th}>Nº Guia</th>
                      <th style={styles.th}>Plano</th>
                      <th style={styles.thRight}>Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    {grupo.itens.map((item, index) => (
                      <tr
                        key={`${item.SOLICITACAO_ID}-${item.EXAME}-${index}`}
                        style={index % 2 === 0 ? styles.rowEven : styles.rowOdd}
                      >
                        <td style={styles.td}>
                          <strong
                            style={{ color: '#1976d2', cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={() => navigate(`/atendimentos/${item.SOLICITACAO_ID}`)}
                            title="Abrir atendimento"
                          >
                            {item.PROTOCOLO || '-'}
                          </strong>
                        </td>
                        <td style={styles.td}>{formatDate(item.DATA)}</td>
                        <td style={styles.td}>{item.PACIENTE_NOME || '-'}</td>
                        <td style={styles.td}>{item.LOCAL_NOME || item.LOCAL || '-'}</td>
                        <td style={styles.td}>{item.EXAME || '-'}</td>
                        <td style={styles.td}>{item.EXAME_DESCRICAO || '-'}</td>
                        <td style={styles.td}>{item.CODIGO_PROCEDIMENTO || '-'}</td>
                        <td style={styles.td}>
                          <span style={getStatusExameBadge(item.EXAME_SITUACAO)}>
                            {getStatusExameLabel(item.EXAME_SITUACAO)}
                          </span>
                        </td>
                        <td style={styles.td}>
                          {(item.MATERIALCOLHIDO || '').trim() === 'T' ? (
                            <span style={{ ...styles.badge, backgroundColor: '#e8f5e9', color: '#2e7d32' }}>Sim</span>
                          ) : (
                            <span style={{ ...styles.badge, backgroundColor: '#fce4ec', color: '#c62828' }}>Não</span>
                          )}
                        </td>
                        <td style={styles.td}>{item.NUMEROGUIA || '-'}</td>
                        <td style={styles.td}>{item.PLANO || '-'}</td>
                        <td style={styles.tdRight}>{formatCurrency(item.VALOR)}</td>
                      </tr>
                    ))}
                    <tr style={styles.subtotalRow}>
                      <td style={styles.subtotalTd} colSpan={11}>
                        Subtotal {grupo.convenioNome || grupo.convenio} ({grupo.totalItens} {grupo.totalItens === 1 ? 'exame' : 'exames'})
                      </td>
                      <td style={styles.subtotalTdRight}>{formatCurrency(grupo.total)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ))}

          {/* Total geral */}
          <div style={styles.totalGeralCard}>
            <span style={styles.totalGeralLabel}>
              Total Geral ({relatorio.grupos.length} {relatorio.grupos.length === 1 ? 'convênio' : 'convênios'} / {relatorio.totalItens.toLocaleString('pt-BR')} exames)
            </span>
            <span style={styles.totalGeralValue}>{formatCurrency(relatorio.totalGeral)}</span>
          </div>
        </>
      )}
    </div>
  );
}

export default RelatorioFaturamento;
